module.exports = __webpack_public_path__ + "img/GPG photo 3.774b59da.png";